import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useApi } from '../api-context';
import { queryKeys } from '../query-keys';
import { extensionSyncListSchema, type ExtensionSyncList } from '../schemas';
import { useToken } from './use-token';

export type AdminExtensionSyncsParams = {
  page?: number;
  limit?: number;
  search?: string;
  kind?: 'doctolib' | 'appointments' | '';
  status?: 'ok' | 'error' | '';
};

/**
 * Les synchronisations reçues de l'extension, les plus récentes d'abord.
 *
 * `refetchInterval` : l'écran sert à voir si l'extension envoie en ce moment,
 * une page qu'il faut recharger à la main répond mal à cette question.
 */
export function useAdminExtensionSyncs({
  page = 1,
  limit = 50,
  search = '',
  kind = '',
  status = '',
}: AdminExtensionSyncsParams = {}) {
  const api = useApi();
  const token = useToken();

  const query = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (search) query.set('search', search);
  if (kind) query.set('kind', kind);
  if (status) query.set('status', status);

  return useQuery({
    queryKey: queryKeys.adminExtension.syncs({ page, limit, search, kind, status }),
    queryFn: () =>
      api.get<ExtensionSyncList>(`/admin/extension/syncs?${query}`, {
        schema: extensionSyncListSchema,
      }),
    enabled: token !== null,
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  });
}
